import { apiAction } from '../../../../shared/store/apiAction';

import * as api from './api';
import { fetchPartnershipAmountDetailsTypes } from './types';

export const fetchPartnershipAmountDetails = apiAction({
  types: fetchPartnershipAmountDetailsTypes,
  apiAction: api.fetchPartnershipAmountDetails,
});
